<template>
    <div id="app" class="theme">
        <router-view />
    </div>
</template>
<script>
export default {
  name: 'App',
  created: function () {
    //在页面加载时读取localStorage里的状态信息
    if (localStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem("store")))
      )
    }

    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  }
}
</script>
<style lang="scss">
#app {
    // min-width: 1300px;
    background-color: rgb(238, 238, 238);
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

::-webkit-scrollbar-track,
::-webkit-scrollbar-thumb  {
        border-radius: 999px;
        border: 5px solid transparent;
}

::-webkit-scrollbar-track  {
        box-shadow: 1px 1px 5px rgba (0, 0, 0, 0.2)  inset;
}

::-webkit-scrollbar-thumb  {
        min-height: 20px;
        background-clip: content-box;
        box-shadow: 0 0 0 5px rgba (0, 0, 0, 0.2)  inset;
}

::-webkit-scrollbar-corner  {
        background: transparent;
}
</style>
